import { ChangeDetectionStrategy, Component, effect, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { AuthService } from './core/auth/auth.service';
import { IntercomService } from './core/intercom/intercom.service';
import { ProfileService } from './core/profile/profile.service';
import { ForbiddenDialogComponent } from './shared/ui/forbidden-dialog/forbidden-dialog.component';
import { ToastHostComponent } from './shared/ui/toast-host/toast-host.component';

@Component({
  selector: 'g-root',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, ToastHostComponent, ForbiddenDialogComponent],
  template: `
    <router-outlet />
    <g-toast-host />
    <g-forbidden-dialog />
  `,
})
export class AppComponent implements OnInit {
  private readonly auth = inject(AuthService);
  private readonly profile = inject(ProfileService);
  private readonly intercom = inject(IntercomService);

  constructor() {
    effect(() => {
      if (this.auth.isAuthenticated()) {
        void this.profile.ensureLoaded().then(() => this.intercom.syncUser());
      } else {
        this.intercom.syncUser();
      }
    });
  }

  async ngOnInit(): Promise<void> {
    this.intercom.init();

    if (typeof window !== 'undefined' && window.location.pathname.endsWith('/login/callback')) {
      return;
    }
    await this.auth.restoreSession();
  }
}
